import React, {PropTypes} from 'react';
import commentFormCreator from './CommentForm';
import CommentRow from './CommentRow';
import UserComment from './components/UserComment';
import A from './components/A';

const CommentList = ({
  question,
  answer,
  comments,
  user,
  onAddCommentClick,
  onCloseCommentClick,
}) => {
  const parentType = answer ? 'answer' : 'question';
  const questionDLM = question.deleted || question.moderated || question.locked;
  const answerDM = (answer && answer.deleted) || (answer && answer.moderated);
  const disableEdit = questionDLM || answerDM;
  const showAddComment = answer ? answer.showAddComment : question.showAddComment;
  const commentFormId = answer ? `newComment-answer-${answer.id}` : 'newComment-question';
  const CommentForm = commentFormCreator(commentFormId);

  const addCommentLink = disableEdit || !comments || (comments && comments.length === 0) ? null : (
    <div className="comment-list__controls ">
      <A className="t-comment-add" onClick={onAddCommentClick}>
        Add comment
      </A>
    </div>);

  const addCommentComponent = showAddComment && user ? (
    <div className="comment-list__form">
      <UserComment userId={user.id} username={user.username} when={user.createdHuman} showText={false} layout="column">
        <CommentForm question={question} answer={answer} onCloseCommentClick={onCloseCommentClick} />
      </UserComment>
    </div>
  ) : addCommentLink;

  const addComment = questionDLM ? null : addCommentComponent;

  const commentRows = (commentList) => (commentList ? commentList.map((comment, key) => (
    <CommentRow
      comment={comment}
      question={question}
      answer={answer}
      user={user}
      key={key}
    />
  )) : null);

  const hasValue = (value) => !!(value && value.length > 0);

  const commentListCss = comments || showAddComment ? 'comment-list' : '';

  return (
    <div className={`t-${parentType}-comment-list ${commentListCss}`}>
      {hasValue(comments) && commentRows(comments)}
      {addComment}
    </div>
  );
};

CommentList.propTypes = {
  question: PropTypes.object.isRequired,
  answer: PropTypes.object,
  comments: PropTypes.array,
  user: PropTypes.object,
  onAddCommentClick: PropTypes.func.isRequired,
  onCloseCommentClick: PropTypes.func.isRequired,
  showAllComments: PropTypes.bool,
  onLoadOlderCommentsClick: PropTypes.func.isRequired,
};

export default CommentList;
